import LpIntroduction from './LpIntroduction'

export default LpIntroduction
